<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modal-header">
            <slot name="header">
              <h4>{{ record.name }}</h4>

              <div class="pull-right">
              <button style="margin-right: .25rem" class="btn btn-success" @click="save(record)">
                Save
              </button>
              <button class="btn btn-default" @click="$emit('close')">
                Close
              </button>
              </div>
            </slot>
          </div>
          <div class="modal-body">
            <slot name="body">
              <form>
                <input type="hidden" v-model="record.id">
                <div class="form-group">
                  <label for="apn">APN</label>
                  <input class="form-control" id="apn" v-model="record.apn">
                </div>
                <div class="form-group">
                  <label for="tra">TRA</label>
                  <input class="form-control" id="tra" v-model="record.tra">
                </div>
                <div class="form-group">
                  <label for="name">Name</label>
                  <input class="form-control" id="name" v-model="record.name">
                </div>
                <div class="form-group">
                  <label for="agency">Agency</label>
                  <v-select v-model="record.agency" :options="agencies"></v-select>
                </div>
                <div class="form-group">
                  <label for="agreement"><add-agreement-button v-bind:record="record"></add-agreement-button> Agreement</label>
                  <v-select v-model="record.agreement" :options="agreements"></v-select>
                </div>
                <div class="form-group">
                  <label for="correspondence"> <add-correspondence-button v-bind:record="record"></add-correspondence-button> Correspondence</label>
                  <v-select v-model="record.correspondence" :options="correspondences"></v-select>
                </div>
                <div class="form-group">
                  <label for="re_recorded_deferral">Re-Recorded Deferral</label>
                  <input type="number" step="1" class="form-control" id="re_recorded_deferral" v-model="record.re_recorded_deferral">
                </div>
                <div class="form-group">
                  <label for="acreage">Acreage</label>
                  <input type="number" step=".01" class="form-control" id="acreage" v-model="record.acreage">
                </div>
                <div class="form-group">
                  <label for="record_state">Record State</label>
                  <v-select v-model="record.state" :options="record_states"></v-select>
                </div>
                <div class="form-group">
                  <label for="notes">Notes</label>
                  <textarea class="form-control" id="notes" v-model="record.notes" rows="3"></textarea>
                </div>
              </form>
            </slot>
          </div>
          <div class="modal-footer">
            <slot name="footer">
              <button class="btn btn-danger mr-auto" @click="remove(record)">
                Delete
              </button>
              <button class="btn btn-success" @click="save(record)">
                Save
              </button>
              <button class="btn btn-default" @click="$emit('close')">
                Close
              </button>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>


<script>
import { BasicSelect } from "vue-search-select";
import { mapState } from "vuex";
import router from "../router";
import AddAgreementButton from "./AddAgreementButton";
import AddCorrespondenceButton from "./AddCorrespondenceButton";

export default {
  name: "record-edit-modal",
  components: {
    BasicSelect,
    AddAgreementButton,
    AddCorrespondenceButton
  },
  computed: mapState([
    "agreements",
    "correspondences",
    "agencies",
    "record",
    "record_states",
    "records"
  ]),
  data() {
    return {
      agreementItem: {},
      agencyItem: {},
      stateItem: {},
      searchText: ""
    };
  },
  methods: {
    onSelectAgreement(item) {
      this.record.agreement = item;
    },
    onSelectAgency(item) {
      this.record.agency = item;
    },
    onSelectRecordState(item) {
      this.record.state = item;
    },
    reset() {
      this.agreementItem = {};
      this.agencyItem = {};
      this.stateItem = {};
    },
    selectOption() {
      this.record.agreement = this.agreements[0];
    },
    save(record) {
      let self = this;
      this.$store.dispatch("updateRecord", record).then(function() {
        console.log("success");
        self.$store.dispatch("loadRecord", { id: self.record.id });
      });
    },
    remove(record) {
      let c = confirm(
        "Are you sure you want to delete " +
          record.name +
          " APN " +
          record.apn +
          "?"
      );
      let self = this;
      if (c == true) {
        this.$emit("close");
        this.$store
          .dispatch("removeRecord", { id: record.id })
          .then(response => {
            let id = response.data.id;
            for (var i = 0; i < self.records.length; i++) {
              if (self.records[i].id == id) {
                self.records.splice(i, 1);
                break;
              }
            }
            router.push({ name: "Home", params: {} });
          });
      }
    }
  }
};
</script>


<style>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 80%;
  height: 70%;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
  overflow: auto;
  overflow: -moz-scrollbars-vertical;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}

/*
   * The following styles are auto-applied to elements with
   * transition="modal" when their visibility is toggled
   * by Vue.js.
   *
   * You can easily play with the modal transition by editing
   * these styles.
   */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
